import { render, staticRenderFns } from "./TableDetailPage.vue?vue&type=template&id=7fe6aa38&scoped=true&lang=pug"
import script from "./TableDetailPage.vue?vue&type=script&lang=js"
export * from "./TableDetailPage.vue?vue&type=script&lang=js"
import style0 from "./TableDetailPage.vue?vue&type=style&index=0&id=7fe6aa38&lang=scss&scoped=true"
import style1 from "./TableDetailPage.vue?vue&type=style&index=1&id=7fe6aa38&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe6aa38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe6aa38')) {
      api.createRecord('7fe6aa38', component.options)
    } else {
      api.reload('7fe6aa38', component.options)
    }
    module.hot.accept("./TableDetailPage.vue?vue&type=template&id=7fe6aa38&scoped=true&lang=pug", function () {
      api.rerender('7fe6aa38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/user_profiles/TableDetailPage.vue"
export default component.exports